module.exports = __webpack_public_path__ + "img/digital.990b8b45.svg";